import { ViewUrl } from '../ViewUrl/ViewUrl'

export const ViewUrlPage = () => <ViewUrl />
